module.exports = __webpack_public_path__ + "static/media/vf_mpants_core.b78f0f77.svg";